import React, { useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';

import AppealsDashboard from './AppealsDashboard';
import MinimalAppealPage from './MinimalAppealPage';

const AppealsPage = () => {
  const { appealId } = useParams();
  const navigate = useNavigate();

  // Show workflow if appealId is provided or if we're creating a new appeal
  const showWorkflow = appealId || window.location.pathname.includes('/new');

  const handleNewAppeal = () => {
    navigate('/appeals/new');
  };

  if (showWorkflow) {
    return <MinimalAppealPage />;
  }

  return <AppealsDashboard onNewAppeal={handleNewAppeal} />;
};

export default AppealsPage;
